import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ScrollText } from "lucide-react";

const ACTION_TONE = {
  "company.create": "text-emerald-300",
  "company.suspend": "text-amber-300",
  "company.activate": "text-emerald-300",
  "support.start": "text-violet-300",
  "support.write": "text-rose-300",
  "support.end": "text-slate-400",
};

export default function PlatformAudit() {
  const [entries, setEntries] = useState([]);
  const [filters, setFilters] = useState({ actor: "", action: "" });

  const load = () => {
    const params = {};
    if (filters.actor) params.actor = filters.actor;
    if (filters.action) params.action = filters.action;
    api.get("/platform/audit", { params }).then((r) => setEntries(r.data.entries)).catch(() => {});
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filters]);

  return (
    <div className="p-6 lg:p-10 max-w-5xl" data-testid="platform-audit-page">
      <div className="flex items-center gap-2 mb-1">
        <ScrollText className="w-5 h-5 text-emerald-400" />
        <h1 className="text-2xl font-bold tracking-tight">Platform Audit Log</h1>
      </div>
      <p className="text-slate-400 text-sm mb-6">Append-only record of all control-plane actions. Cannot be edited or deleted.</p>

      <div className="flex flex-wrap gap-2 mb-5">
        <input
          value={filters.actor}
          onChange={(e) => setFilters((f) => ({ ...f, actor: e.target.value }))}
          placeholder="Filter by actor email"
          data-testid="audit-filter-actor"
          className="bg-slate-900 border border-white/10 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500/40"
        />
        <input
          value={filters.action}
          onChange={(e) => setFilters((f) => ({ ...f, action: e.target.value }))}
          placeholder="Filter by action (e.g. support)"
          data-testid="audit-filter-action"
          className="bg-slate-900 border border-white/10 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500/40"
        />
      </div>

      <div className="space-y-2" data-testid="audit-list">
        {entries.length === 0 && <div className="text-slate-500 text-sm">No audit entries.</div>}
        {entries.map((e, i) => (
          <div key={e.id || i} className="rounded-lg bg-slate-900/70 ring-1 ring-white/5 px-4 py-3" data-testid={`audit-entry-${i}`}>
            <div className="flex items-center justify-between gap-3">
              <span className={`text-xs font-bold ${ACTION_TONE[e.action] || "text-slate-300"}`}>{e.action}</span>
              <span className="text-[11px] text-slate-500 tabular-nums">{(e.ts || "").replace("T", " ").slice(0, 19)}</span>
            </div>
            <div className="text-sm text-slate-200 mt-1">{e.detail}</div>
            <div className="text-[11px] text-slate-500 mt-1">
              {e.actor_email}
              {e.reason ? ` · reason: ${e.reason}` : ""}
              {e.ticket_ref ? ` · ${e.ticket_ref}` : ""}
              {e.ip ? ` · ${e.ip}` : ""}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
